/**
 * Centralized permissions registry for the application.
 * These permission keys are checked against user's feature_flags array.
 *
 * Usage:
 * - Import: import { PERMISSIONS } from '@/access/permissions'
 * - Use in components: hasPermission(PERMISSIONS.REPORTS)
 * - Use in router meta: permission: PERMISSIONS.READ_USERS
 */
export const PERMISSIONS = Object.freeze({
  // Contact Management
  CONTACTS: 'contacts',
  ADD_CONTACTS: 'add_contacts',
  DELETE_CONTACTS: 'delete_contacts',
  IMPORT_CONTACTS: 'import_contacts',
  CONTACTS_RELATIONSHIPS: 'contacts_relationships',

  // Messaging & Communication
  CONVERSATIONS: 'conversations',
  GROUP_MESSAGES: 'group_messages',
  SEND_SMS: 'send_sms',

  // Campaigns & Automations
  CAMPAIGNS: 'campaigns',
  AUTOMATIONS: 'automations',

  // Content Management
  LESSONS: 'lessons',
  CUSTOM_OBJECTS: 'custom_objects',
  MANAGE_CUSTOM_OBJECTS: 'manage_custom_objects',
  MANAGE_CUSTOM_RECORDS: 'manage_custom_records',
  MANAGE_FORMS: 'manage_forms',
  VIEW_FORM_SUBMISSIONS: 'view_form_submissions',
  CREATE_FORM_SUBMISSIONS: 'create_form_submissions',

  // AI Agents (tiered: view < edit < manage)
  VIEW_AGENTS: 'view_agents',
  EDIT_AGENTS: 'edit_agents',
  MANAGE_AGENTS: 'manage_agents',

  // Reporting & Analytics
  REPORTS: 'reports',

  // User Management
  CREATE_USERS: 'create_users',
  READ_USERS: 'read_users',
  UPDATE_USERS: 'update_users',

  // Team Management
  TEAMS: 'teams',

  // Settings & Configuration
  HOOKS: 'hooks',
  MANAGE_BILLING: 'manage_billing',
  MANAGE_LINKS: 'manage_links',
  MANAGE_TAGS: 'manage_tags',
  LINKS: 'links',
  TAGS: 'tags',
});
